<div class="modal-content" style="max-height: 250px; overflow-y: auto;width: 100%; " (scroll)="onScroll($event)">
  <div class="modal-content-results">
    <!-- Country list with Tailwind styling -->
    <div class="divide-y divide-gray-100">
      <div *ngFor="let phone of displayedPhoneExtensions" 
           (click)="onSelectPhone(phone)"
           class="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
        <span [class]="'fi fi-' + phone.code_2.toLowerCase() + ' mr-3'"></span>
        <span class="text-[13px] text-gray-700">{{ phone.name_es }}</span>
      </div>
      
      <!-- No results message -->
      <div *ngIf="displayedPhoneExtensions.length === 0" 
           class="px-3 py-4 text-center text-[13px] text-gray-500">
        No countries found
      </div>
      
      <!-- Loading indicator -->
      <div *ngIf="loading && !allLoaded" 
           class="flex items-center justify-center py-3">
        <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-primary"></div>
        <span class="ml-2 text-[12px] text-gray-500">Loading more...</span>
      </div>
    </div>
  </div>
</div>